import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.w3q_1 = new (MarkdownContent())('aboutMd', 'connectSuccessMd', 'contributionStartMd', 'boostMd', 'recentInfoMd', 'installSuccessMd');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var MarkdownContentClass;
function MarkdownContent() {
  if (MarkdownContentClass === VOID) {
    class $ {
      constructor(aboutMd, connectSuccessMd, contributionStartMd, boostMd, recentInfoMd, installSuccessMd) {
        Companion_getInstance();
        this.x3q_1 = aboutMd;
        this.y3q_1 = connectSuccessMd;
        this.z3q_1 = contributionStartMd;
        this.a3r_1 = boostMd;
        this.b3r_1 = recentInfoMd;
        this.c3r_1 = installSuccessMd;
      }
      toString() {
        return 'MarkdownContent(aboutMd=' + this.x3q_1 + ', connectSuccessMd=' + this.y3q_1 + ', contributionStartMd=' + this.z3q_1 + ', boostMd=' + this.a3r_1 + ', recentInfoMd=' + this.b3r_1 + ', installSuccessMd=' + this.c3r_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.x3q_1);
        result = imul(result, 31) + getStringHashCode(this.y3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z3q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c3r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MarkdownContent()))
          return false;
        if (!(this.x3q_1 === other.x3q_1))
          return false;
        if (!(this.y3q_1 === other.y3q_1))
          return false;
        if (!(this.z3q_1 === other.z3q_1))
          return false;
        if (!(this.a3r_1 === other.a3r_1))
          return false;
        if (!(this.b3r_1 === other.b3r_1))
          return false;
        if (!(this.c3r_1 === other.c3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MarkdownContent');
    MarkdownContentClass = $;
  }
  return MarkdownContentClass;
}
//region block: exports
export {
  MarkdownContent as MarkdownContent25fmztzs0fh3a,
  Companion_getInstance as Companion_getInstance3kqyk8vnxc5xb,
};
//endregion

//# sourceMappingURL=MarkdownContent.mjs.map
